import { defineComponent as _defineComponent } from 'vue'
import { withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e82c35c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create-streak-modal__fields" }

import { ref, computed } from 'vue';

import DSModal from '@/design-system/DSModal.vue';
import DSTextField from '@/design-system/DSTextField.vue';
import DSSelect from '@/design-system/DSSelect.vue';

import { useStore } from '@/store';
import { CREATE_STREAK } from '@/store/types/actions';

interface ProjectOption {
  label: string;
  value: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DCStreaksCreate',
  setup(__props, { expose: __expose }) {

const store = useStore();
const show_modal = ref(false);
const streak_name = ref('');
const projects_model = ref<number[]>([]);
const request_pending = ref(false);
const projects = computed(() => store.state.project.projects);

const getParsedProjects = computed<ProjectOption[]>(() => {
  return projects.value.map((project) => ({
    label: project.name,
    value: project.id,
  }));
});

const handleCreateStreak = async () => {
  request_pending.value = true;

  if (streak_name.value) {
    await store.dispatch(CREATE_STREAK, {
      name: streak_name.value,
      projects: projects_model.value,
    });

    show_modal.value = false;
    streak_name.value = '';
    projects_model.value = [];
  }

  request_pending.value = false;
};

const handleCancel = () => {
  show_modal.value = false;
  streak_name.value = '';
  projects_model.value = [];
};

__expose({ show_modal });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DSModal, {
    modelValue: show_modal.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((show_modal).value = $event)),
    title: "New Streak",
    loading: request_pending.value,
    "confirm-label": "Create Streak",
    onConfirm: handleCreateStreak,
    onCancel: handleCancel
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(DSTextField, {
          modelValue: streak_name.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((streak_name).value = $event)),
          label: "Streak Name",
          placeholder: "Enter streak name",
          icon: "whatshot",
          autofocus: "",
          onKeyup: _withKeys(handleCreateStreak, ["enter"]),
          "aria-label": "Streak name"
        }, null, 8, ["modelValue", "onKeyup"]),
        _createVNode(DSSelect, {
          modelValue: projects_model.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((projects_model).value = $event)),
          options: getParsedProjects.value,
          label: "Projects",
          icon: "folder",
          multiple: "",
          clearable: "",
          "aria-label": "Select projects"
        }, null, 8, ["modelValue", "options"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "loading"]))
}
}

})